import { useEffect, useState } from "react";
import api from "@/utils/api";

// The one amount a customer may see per shipment (server decides): the invoice amount, or for a paid walk-in the amount paid.
// Anything else shows "To be confirmed". Booked / carrier prices are never sent to customer logins.
export default function useCustomerAmounts(ids) {
  const key = (ids || []).filter(Boolean).join(",");
  const [items, setItems] = useState({});
  useEffect(() => {
    if (!key) { setItems({}); return undefined; }
    let live = true;
    api.get("/v2/my-booking/amounts", { params: { ids: key } })
      .then((r) => { if (live) setItems(r.data?.items || {}); })
      .catch(() => { if (live) setItems({}); });
    return () => { live = false; };
  }, [key]);
  return items;
}

export const amountText = (a) => (a && a.amount != null ? `₹${Number(a.amount).toLocaleString("en-IN", { maximumFractionDigits: 2 })}` : (a?.label && a.label !== "To be confirmed" ? a.label : "To be confirmed"));
